import React from "react";
import { Box, Modal } from "@mui/material";
import GarmentViewNavigator from "./GarmentViewNavigator";
import ViewToolbar from "./ViewToolbar";
import { styled } from "@mui/material/styles";
import MobileDraggablePatch from "./MobileDraggablePatch";

const StyledModal = styled(Modal)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "end",
  backgroundColor: "transparent",
}));

const StyledWrapper = styled(Box)(({ side = "right" }) => ({
  position: "fixed",
  top: "80px",
  [side]: "15px",
  zIndex: 2,
}));

const WorkZoneWrapper = ({
  isMobile = false,
  children,
  canvasImage,
  handleToolbarChange,
  variants,
  openMobileView,
  setMobileView,
  setDrawerOpen,
  patch,
  orderPreviewMode,
}) => {
  const viewToolbar = (
    <StyledWrapper side="right">
      <ViewToolbar
        canvasImage={canvasImage}
        variants={variants}
        handleToolbarChange={handleToolbarChange}
        openMobileView={openMobileView}
        setMobileView={setMobileView}
      />
    </StyledWrapper>
  );

  const toolBar = React.useMemo(() => {
    return openMobileView ? (
      <StyledModal open={true}>
        <Box sx={{ border: "none !important", outline: "none !important" }}>{viewToolbar}</Box>
      </StyledModal>
    ) : (
      viewToolbar
    );
  }, [openMobileView, canvasImage]);

  return isMobile ? (
    <Box
      sx={{
        position: "relative",
      }}
    >
      {children}
      <GarmentViewNavigator
        canvasImage={canvasImage}
        handleToolbarChange={handleToolbarChange}
        variants={variants}
      />
      {toolBar}
      {!orderPreviewMode && (
        <StyledWrapper side="left">
          <MobileDraggablePatch patch={patch} morePatches={setDrawerOpen} />
        </StyledWrapper>
      )}
    </Box>
  ) : (
    <React.Fragment>{children}</React.Fragment>
  );
};

export default WorkZoneWrapper;
